export default __webpack_public_path__ + "static/media/arrow_down.e99f8d7e.svg";